module.exports = __webpack_public_path__ + "static/media/view.d905a65a.svg";